import React, { Fragment } from 'react';

import { Task } from 'entities/task';
import { CollapseAllTabs } from 'features';

import { EmptyTasksBlurContainer } from './EmptyTasksBlurContainer';
import { NoTaskFoundPlaceholder } from './NoTaskFoundPlaceholder';
import { TaskListSkeleton } from './TaskListSkeleton';
import { TasksGrouper } from './TasksGrouper/TasksGrouper';
import { useIsOnlyCompleted } from '../../../entities/task/hooks/useIsOnlyCompleted';
import { useTaskList } from '../hooks/useTaskList';
import { TabTerms } from '../model/TabTerms';

// todo декомпозировать логику внутри map

export const TaskList = () => {
    const {
        isEmptyTasksList,
        isShowCompleted,
        tabsOfGrouper,
        isLoading,
        isFiltered,
        filteredTabs,
        tabs,
        noTaskFound,
    } = useTaskList();
    const isOnlyCompletedFound = useIsOnlyCompleted(filteredTabs?.list);

    return (
        <>
            {isLoading && <TaskListSkeleton />}
            {isEmptyTasksList && !isLoading && !isFiltered && <EmptyTasksBlurContainer />}
            <CollapseAllTabs />
            {noTaskFound && !isLoading && isFiltered && <NoTaskFoundPlaceholder />}
            {!noTaskFound && !isShowCompleted && isFiltered && isOnlyCompletedFound && (
                <NoTaskFoundPlaceholder />
            )}

            {tabsOfGrouper.map((tab, index) => {
                if (tab === 'completed' && !isShowCompleted) return null;
                if (
                    tab === 'completed' &&
                    isShowCompleted &&
                    filteredTabs != null &&
                    filteredTabs?.list?.completed?.length === 0 &&
                    isFiltered
                ) {
                    return null;
                }

                if (
                    tab != 'completed' &&
                    tabs?.list[tab]?.length === 0 &&
                    filteredTabs?.list?.completed?.length === 0
                )
                    return null;

                if (
                    tab === 'no_term' &&
                    filteredTabs != null &&
                    filteredTabs?.list[tab]?.length === 0
                )
                    return null;

                const defaultCollapsed = !(index === 2 || index === 3 || tab === 'no_term');
                const renderedData = tabs?.list[tab];
                const tasks = filteredTabs ? filteredTabs?.list[tab] : renderedData;

                return (
                    <TasksGrouper
                        key={tab + index}
                        isEmpty={tasks?.length}
                        grouperTitle={TabTerms[tab as keyof typeof TabTerms] || tab}
                        initialCollapsing={defaultCollapsed}
                    >
                        {tasks.map((id, i, arr) => (
                            // const needDivider = arr?.length > 1 && i != arr?.length - 1;
                            <Fragment key={id}>
                                <Task uid={id} type="list" isDone={tab === 'completed'} />
                                {/* {needDivider && <Divider />} */}
                            </Fragment>
                        ))}
                    </TasksGrouper>
                );
            })}
        </>
    );
};

// todo не удалять, это возможное решение ленивой загрузки

// import React, { useMemo, useState, useEffect, useRef, useCallback } from 'react';
// import cls from './index.module.css';
// import { Task } from 'entities/task';
// import { TasksGrouper } from './TasksGrouper/TasksGrouper';
// import { getTabsOfGrouper } from 'entities/task/lib/getTabsOfGrouper';
// import { TabTerms } from '../model/TabTerms';
// import { useAppSelector } from '../../../store';
// import { TaskListSkeleton } from './TaskListSkeleton';
//
// const TabVisibilityWrapper = ({
//     tab,
//     isExpanded,
//     onVisibilityChange,
//     children,
// }: {
//     tab: string;
//     isExpanded: boolean;
//     onVisibilityChange: (tab: string, isVisible: boolean) => void;
//     children: React.ReactNode;
// }) => {
//     const ref = useRef<HTMLDivElement>(null);
//
//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 onVisibilityChange(tab, entry.isIntersecting);
//             },
//             { threshold: 0.1 } // Точность попадания в видимость
//         );
//
//         if (ref.current) observer.observe(ref.current);
//
//         return () => {
//             if (ref.current) observer.unobserve(ref.current);
//         };
//     }, [tab, onVisibilityChange]);
//
//     return (
//         <div ref={ref}>
//             <TasksGrouper
//                 grouperTitle={TabTerms[tab as keyof typeof TabTerms] || tab}
//                 initialCollapsing={!isExpanded} // Управляем сворачиванием
//             >
//                 {children}
//             </TasksGrouper>
//         </div>
//     );
// };
//
// export const TaskList = () => {
//     const { tabs, filteredTabs, ganttTabs, isShowGanttTabs } = useAppSelector(
//         (state) => state.tasksInformationReducer
//     );
//     const tasksInformationData = useAppSelector((state) => state.tasksInformationReducer);
//     const { isLoading: isLoadingFromStore } = useAppSelector((state) => state.tasksReducer);
//
//     const [isLoading, setIsLoading] = useState(isLoadingFromStore);
//     const [activeTab, setActiveTab] = useState<string | null>(null); // Активный таб
//     const [visibilityMap, setVisibilityMap] = useState<Record<string, boolean>>({}); // Видимость табов
//
//     useEffect(() => {
//         if (!isLoadingFromStore) {
//             const timeout = setTimeout(() => setIsLoading(false), 0);
//             return () => clearTimeout(timeout);
//         }
//     }, [isLoadingFromStore]);
//
//     const tabsOfGrouper = useMemo(() => {
//         if (filteredTabs) return getTabsOfGrouper(filteredTabs?.list);
//         if (isShowGanttTabs) return getTabsOfGrouper(ganttTabs?.list);
//         return getTabsOfGrouper(tabs?.list);
//     }, [tabs?.list, filteredTabs, isShowGanttTabs, ganttTabs?.list]);
//
//     const handleVisibilityChange = useCallback((tab: string, isVisible: boolean) => {
//         setVisibilityMap((prev) => ({
//             ...prev,
//             [tab]: isVisible,
//         }));
//
//         // Разворачиваем таб, если он стал видимым
//         if (isVisible) {
//             setActiveTab(tab);
//         }
//     }, []);
//
//     return (
//         <>
//             {isLoading && <TaskListSkeleton />}
//             {tabsOfGrouper.map((tab) => {
//                 if (tab !== 'completed' && tab !== 'no_term' && tabs.list[tab]?.length === 0) {
//                     return null;
//                 }
//                 return (
//                     <TabVisibilityWrapper
//                         key={tab}
//                         tab={tab}
//                         isExpanded={activeTab === tab} // Разворачиваем только активный таб
//                         onVisibilityChange={handleVisibilityChange}
//                     >
//                         <div className={cls.taskListInformationLayout}>
//                             {isShowGanttTabs
//                                 ? ganttTabs.list[tab].map((id) => (
//                                       <Task
//                                           uid={id}
//                                           key={id}
//                                           type="list"
//                                           isDone={tab === 'completed'}
//                                       />
//                                   ))
//                                 : tabs.list[tab].map((id) => (
//                                       <Task
//                                           uid={id}
//                                           key={id}
//                                           type="list"
//                                           isDone={tab === 'completed'}
//                                       />
//                                   ))}
//                         </div>
//                     </TabVisibilityWrapper>
//                 );
//             })}
//         </>
//     );
// };
